import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiSun, FiMoon } from 'react-icons/fi';

const Navbar = ({ theme, toggleTheme }) => {
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    if (path === '/blogs') return location.pathname === '/blogs' || location.pathname.startsWith('/blog/');
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand">
        <img src="/twe-logo.png" alt="twe logo" className="brand-logo" />
        <span className="brand-text">
          <span className="the">the</span>
          <span className="wicked">wicked</span>
          <span className="engineer">engineer</span>
        </span>
      </Link>
      <div className="navbar-right">
        <div className="navbar-links">
          <Link to="/blogs" className={isActive('/blogs') ? 'active' : ''}>Blogs</Link>
          <Link to="/projects" className={isActive('/projects') ? 'active' : ''}>Projects</Link>
          <Link to="/about" className={isActive('/about') ? 'active' : ''}>About Me</Link>
          <Link to="/subscribe" className={isActive('/subscribe') ? 'active' : ''}>Subscribe</Link>
        </div>
        <button
          className="theme-toggle"
          onClick={toggleTheme}
          title={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
        >
          {theme === 'light' ? <FiMoon /> : <FiSun />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
